export const SHIPPING_FORM = 'shipping/form'
